export const type = 'addSavedOrder';

const addSavedOrder = (order) => ({
    type,
    payload: order,
});

export default addSavedOrder;